export default __webpack_public_path__ + "static/China-5fea2b0ee1968bb2f57cafeb4cd410f9.png";